<div class="w-full flex flex-col items-center justify-center p-2">
  <ng-container *ngTemplateOutlet="details"></ng-container>
</div>
